import React, { useRef, useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { generateQRDataFromObject } from "../../utils/ticketUtils"
import { OBJECT_TYPE_TICKET } from "../../constants/ticket";
import styles from "./TicketCard.module.css"

const TICKET_WIDTH_INCHES = 5.63;
const TICKET_WIDTH_PX = TICKET_WIDTH_INCHES * 96; // 96dpi = ~540px

const TicketCard = ({ ticket, style = {}, disableScaling=false, objectType=OBJECT_TYPE_TICKET}) => {
  const {
    name,
    ticketNumber,
    price,
    variantDetails,
  } = ticket;

  const qrPayload = generateQRDataFromObject(ticket, objectType)

  const containerRef = useRef();
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!containerRef.current) return;
    if (disableScaling) {
      setScale(1)
      return
    }
    const parentWidth = containerRef.current.parentElement.offsetWidth;
    const newScale = parentWidth < TICKET_WIDTH_PX ? parentWidth / TICKET_WIDTH_PX : 1;
    setScale(newScale);
  }, []);

  const containerStyle = {
    backgroundImage: style.backgroundImage && style.backgroundImage.med ? `url(${style.backgroundImage.med})` : "none",
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    fontFamily:
      style.font === "serif"
        ? "Georgia, serif"
        : style.font === "mono"
        ? "monospace"
        : "Arial, sans-serif",
    color: style.color || "var(--black)",
    width: `${TICKET_WIDTH_INCHES}in`,
    height: "1.97in",
    padding: "1em",
    border: "1px solid var(--mid-grey)",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: style.backgroundColor || "var(--white)",
    transform: `scale(${scale})`,
    transformOrigin: "top left",
  };

  return (
    <div className="ticket-card-wrapper" ref={containerRef} style={{ overflow: "hidden" }}>
      <div className="margin-bottom-1em" style={containerStyle}>
        <div className="display-flex flex-direction-column justify-content-space-between flex-grow-1">
          <div style={{backgroundColor: style.textBackgroundColor}} className="padding-5px border-radius-4px width-fit-content">
            <div className={`font-weight-600 ${styles.name}`}>{name}</div>
            {variantDetails && (
              <div className="margin-top-5px">{variantDetails}</div>
            )}
            <div className="font-size-16px margin-top-5px">
              Ticket #: <span className={styles.ticketNumber}>{ticketNumber}</span>
            </div>
            <div className="font-size-16px">Price: <span className={styles.price}>${price.toFixed(2)}</span></div>
          </div>
          {style.footerText && (
            <div className="font-size-14px color-grey margin-top-1em">{style.footerText}</div>
          )}
        </div>
        <div className="margin-left-1em ">
          <QRCodeSVG value={qrPayload} size={155} marginSize={4}/>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
